<div
  class="floating-shelf"
  [class.drop-target]="isDropTarget"
  (mousemove)="onDragOver()"
  (mouseleave)="onDragLeave()"
>
  <div class="floating-shelf-label">
    <i class="bi bi-bookmark-star"></i>
    <span>Floating Shelf</span>
  </div>

  <div class="floating-shelf-items">
    @for (item of items; track item.productId) {
      @let ref = getProduct(item.productId);
      <div class="floating-shelf-item">
        <div class="floating-shelf-item-image">
          <app-image
            [productId]="item.productId"
            [orientation]="ref?.orientation"
            [squeeze]="0"
            [thumbnail]="true"
          ></app-image>
        </div>
        <div class="floating-shelf-item-info">
          <span class="floating-shelf-item-name" [title]="ref?.description">
            {{ ref?.description ?? 'Product ' + item.productId }}
          </span>
          <span class="floating-shelf-item-capacity badge text-bg-primary">
            Cap: {{ item.capacity }}
          </span>
        </div>
        @if (canEdit) {
          <div class="floating-shelf-item-actions">
            <button
              type="button"
              class="btn btn-sm btn-link p-0"
              title="Configure capacity"
              (click)="configure(item)"
            >
              <i class="bi bi-gear"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-link p-0 text-danger"
              title="Remove from floating shelf"
              (click)="remove(item)"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        }
      </div>
    } @empty {
      <div class="floating-shelf-empty">
        Drag products here to add them to the floating shelf
      </div>
    }
  </div>
</div>
